export default "__VITE_ASSET__Dr1l8_uo__"